/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { __extends } from "tslib";
import { Base, String_$type, runOn, delegateRemove, delegateCombine, markType, INotifyPropertyChanged_$type, PropertyChangedEventArgs, EnumUtil, enumGetBox } from "igniteui-react-core";
import { Dictionary$2 } from "igniteui-react-core";
import { XIcon } from "igniteui-react-inputs";
import { OperatorSelectorOpeningEventArgs } from "./OperatorSelectorOpeningEventArgs";
import { Popup } from "igniteui-react-layouts";
import { Rect } from "igniteui-react-core";
import { OperatorModel } from "./OperatorModel";
import { BaseDOMEventProxy } from "igniteui-react-core";
import { stringFormat } from "igniteui-react-core";
import { SRProvider } from "igniteui-react-core";
import { TemplateColumn } from "./TemplateColumn";
import { List$1 } from "igniteui-react-core";
import { ColumnComparisonConditionOperatorType_$type } from "./ColumnComparisonConditionOperatorType";
import { DataSourceSchemaPropertyType_$type } from "igniteui-react-core";
import { OperatorSelectorValueChangedEventArgs } from "./OperatorSelectorValueChangedEventArgs";
import { TextColumn } from "./TextColumn";
import { ColumnWidth } from "./ColumnWidth";
import { stringIsNullOrWhiteSpace } from "igniteui-react-core";
/**
 * @hidden
 */
var ComparisonOperatorSelectorView = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(ComparisonOperatorSelectorView, _super);
    function ComparisonOperatorSelectorView(a) {
        var _this = _super.call(this) || this;
        _this.i = null;
        _this.d = null;
        _this.c = null;
        _this.h = null;
        _this.f = null;
        _this.m = null;
        _this.b = null;
        _this.j = 0;
        _this.e = new Dictionary$2(String_$type, XIcon.$, 0);
        _this.k = 0;
        _this.l = 0;
        _this.g = null;
        _this.a = null;
        _this.a = a;
        _this.l = 240;
        return _this;
    }
    ComparisonOperatorSelectorView.prototype.t = function (a) {
        var _this = this;
        if (a == null) {
            var b = this.a;
            b.opening = delegateRemove(b.opening, runOn(this, this.r));
            var c = this.a;
            c.closing = delegateRemove(c.closing, runOn(this, this.n));
            return;
        }
        var d = this.a;
        d.opening = delegateCombine(d.opening, runOn(this, this.r));
        var e = this.a;
        e.closing = delegateCombine(e.closing, runOn(this, this.n));
        this.g = a;
        this.d = new Popup();
        this.d.provideRenderer(this.g);
        this.i = this.g.createElement("div");
        this.i.setStyleProperty("background-color", "rgba(255,255,255,1)");
        this.i.setStyleProperty("width", this.l + "px");
        this.d.appendPopupContent(this.i);
        this.h = this.g.createElement("div");
        this.f = this.g.getSubRenderer(this.h);
        this.c = new XIcon();
        this.c.provideContainer(this.f);
        this.h.setStyleProperty("cursor", "pointer");
        this.g.append(this.h);
        this.h.listen("mousedown", runOn(this, this.q));
        this.g.getPortal(this.i, "DataGrid", function (f) {
            _this.m = f.componentRef;
            _this.m.height = '100%';
            _this.m.scrollbarStyle = 'Default';
            _this.b = (_this.m.i);
            _this.a.d8(_this.d, _this.c, _this.b);
        }, false);
    };
    ComparisonOperatorSelectorView.prototype.v = function () {
        var rect_ = this.h.getNativeElement().getBoundingClientRect();
        var a = new Rect(4);
        a.left = (rect_.left + window.pageXOffset);
        a.top = (rect_.top + window.pageYOffset);
        a.right = (rect_.right + window.pageXOffset);
        a.bottom = (rect_.bottom + window.pageYOffset);
        var b = this.g.rootWrapper.width();
        var filterIcon_ = this.g.rootWrapper.getNativeElement();
        var boundingRect_ = filterIcon_.getBoundingClientRect();
        var c = (boundingRect_.left);
        var d = (boundingRect_.right);
        var e = (window.innerWidth);
        var f = true;
        var g = c - (e - this.l - 10);
        if (g > 0) {
            f = false;
        }
        if (f) {
            a.left = this.g.rootWrapper.getOffset().left;
        }
        else {
            var h = this.g.rootWrapper.getOffset().left - g;
            a.left = h;
        }
        return a;
    };
    ComparisonOperatorSelectorView.prototype.s = function (a, b) {
        var c = a;
        var d = null;
        if (c.element.getChildCount() == 0) {
            c.element.setStyleProperty("display", "inline-block");
            c.element.setStyleProperty("vertical-align", "middle");
            var e = this.g.createElement("div");
            var f = this.j.toString();
            e.setAttribute("id", f);
            var g = this.g.getSubRenderer(e);
            d = new XIcon();
            d.provideContainer(g);
            e.setStyleProperty("width", "24px");
            e.setStyleProperty("height", "24px");
            c.element.append(e);
            this.e.addItem(f, d);
            this.j++;
        }
        else {
            var h = c.element.getChildAt(0).getNativeElement();
            var i = (h.id);
            if (this.e.containsKey(i)) {
                d = this.e.item(i);
            }
        }
        d.svgPath = b.Icon;
    };
    ComparisonOperatorSelectorView.prototype.q = function (a) {
        this.a.eh();
    };
    ComparisonOperatorSelectorView.prototype.r = function (a, b) {
        this.i.setStyleProperty("height", stringFormat("{0}px", this.a.x()));
        this.d.ar();
        document.addEventListener("keydown", runOn(this, this.onDocumentKeyDown), false);
        document.addEventListener("mousedown", runOn(this, this.onDocumentMouseDown), false);
    };
    ComparisonOperatorSelectorView.prototype.n = function (a, b) {
        document.removeEventListener("keydown", this.onDocumentKeyDown, false);
        document.removeEventListener("mousedown", this.onDocumentMouseDown, false);
    };
    ComparisonOperatorSelectorView.prototype.onDocumentKeyDown = function (a) {
        var b = a;
        if (BaseDOMEventProxy.cv(b) == 8) {
            this.a.d5();
        }
    };
    ComparisonOperatorSelectorView.prototype.onDocumentMouseDown = function (a) {
        var b = a;
        var c = (b.srcElement);
        var d = this.g.rootWrapper.getNativeElement();
        var e = this.i.getNativeElement();
        if (!d.contains(c) && !e.contains(c)) {
            this.a.d5();
        }
    };
    ComparisonOperatorSelectorView.prototype.u = function (a) {
        this.m.dataSource = a;
    };
    ComparisonOperatorSelectorView.$t = markType(ComparisonOperatorSelectorView, 'ComparisonOperatorSelectorView');
    return ComparisonOperatorSelectorView;
}(Base));
export { ComparisonOperatorSelectorView };
/**
 * @hidden
 */
var ComparisonOperatorSelector = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(ComparisonOperatorSelector, _super);
    function ComparisonOperatorSelector() {
        var _this = _super.call(this) || this;
        _this.propertyChanged = null;
        _this.q = null;
        _this.e = null;
        _this.p = null;
        _this.o = null;
        _this.n = null;
        _this.f = null;
        _this.m = null;
        _this.u = null;
        _this.t = null;
        _this.g = null;
        _this.s = false;
        _this.a = 0;
        _this.ac = null;
        _this.w = 0;
        _this.c = 0;
        _this.v = 250;
        _this.valueChanged = null;
        _this.opening = null;
        _this.closing = null;
        _this.e = new ComparisonOperatorSelectorView(_this);
        _this.t = new List$1(OperatorModel.$, 0);
        return _this;
    }
    ComparisonOperatorSelector.prototype.eb = function (a, b, c) {
        this.ed(a, b, c);
        if (this.propertyChanged != null) {
            this.propertyChanged(this, new PropertyChangedEventArgs(a));
        }
    };
    ComparisonOperatorSelector.prototype.ed = function (a, b, c) {
        switch (a) {
            case "Value":
                this.ec(EnumUtil.getEnumValue(ColumnComparisonConditionOperatorType_$type, b), EnumUtil.getEnumValue(ColumnComparisonConditionOperatorType_$type, c));
                break;
            case "DataType":
                this.d1();
                break;
        }
    };
    Object.defineProperty(ComparisonOperatorSelector.prototype, "r", {
        get: function () {
            if (this.q == null) {
                this.q = new SRProvider(this.e.g);
                this.q.cb("DataGrid");
            }
            return this.q;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ComparisonOperatorSelector.prototype, "i", {
        get: function () {
            return this.g;
        },
        set: function (a) {
            this.g = a;
            if (this.g != null) {
                if (this.g.a == 44) {
                    this.ac = this.g.c;
                    this.w = this.g.b;
                }
                if (!this.s) {
                    this.b = this.g.a;
                }
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ComparisonOperatorSelector.prototype, "b", {
        get: function () {
            return this.a;
        },
        set: function (a) {
            var b = this.a;
            this.a = a;
            if (b != this.a || this.a == 44) {
                this.eb("Value", enumGetBox(ColumnComparisonConditionOperatorType_$type, b), enumGetBox(ColumnComparisonConditionOperatorType_$type, this.a));
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ComparisonOperatorSelector.prototype, "d", {
        get: function () {
            return this.c;
        },
        set: function (a) {
            var b = this.c;
            this.c = a;
            if (b != this.c) {
                this.eb("DataType", enumGetBox(DataSourceSchemaPropertyType_$type, b), enumGetBox(DataSourceSchemaPropertyType_$type, this.c));
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ComparisonOperatorSelector.prototype, "y", {
        get: function () {
            return this.v;
        },
        set: function (a) {
            this.v = a;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ComparisonOperatorSelector.prototype, "db", {
        get: function () {
            var a = this.r.b1("ComparisonOperator_True");
            return !stringIsNullOrWhiteSpace(a) ? a : "True";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ComparisonOperatorSelector.prototype, "ci", {
        get: function () {
            var a = this.r.b1("ComparisonOperator_False");
            return !stringIsNullOrWhiteSpace(a) ? a : "False";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ComparisonOperatorSelector.prototype, "ch", {
        get: function () {
            var a = this.r.b1("ComparisonOperator_Equals");
            return !stringIsNullOrWhiteSpace(a) ? a : "Equals";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ComparisonOperatorSelector.prototype, "cx", {
        get: function () {
            var a = this.r.b1("ComparisonOperator_NotEquals");
            return !stringIsNullOrWhiteSpace(a) ? a : "Not equals";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ComparisonOperatorSelector.prototype, "cp", {
        get: function () {
            var a = this.r.b1("ComparisonOperator_LessThan");
            return !stringIsNullOrWhiteSpace(a) ? a : "Less than";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ComparisonOperatorSelector.prototype, "cq", {
        get: function () {
            var a = this.r.b1("ComparisonOperator_LessThanOrEqualTo");
            return !stringIsNullOrWhiteSpace(a) ? a : "Less than or equal to";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ComparisonOperatorSelector.prototype, "cj", {
        get: function () {
            var a = this.r.b1("ComparisonOperator_GreaterThan");
            return !stringIsNullOrWhiteSpace(a) ? a : "Greater than";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ComparisonOperatorSelector.prototype, "ck", {
        get: function () {
            var a = this.r.b1("ComparisonOperator_GreaterThanOrEqualTo");
            return !stringIsNullOrWhiteSpace(a) ? a : "Greater than or equal to";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ComparisonOperatorSelector.prototype, "c9", {
        get: function () {
            var a = this.r.b1("ComparisonOperator_Top");
            return !stringIsNullOrWhiteSpace(a) ? a : "Top";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ComparisonOperatorSelector.prototype, "b9", {
        get: function () {
            var a = this.r.b1("ComparisonOperator_Bottom");
            return !stringIsNullOrWhiteSpace(a) ? a : "Bottom";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ComparisonOperatorSelector.prototype, "da", {
        get: function () {
            var a = this.r.b1("ComparisonOperator_TopPercentile");
            return !stringIsNullOrWhiteSpace(a) ? a : "Top percentile";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ComparisonOperatorSelector.prototype, "ca", {
        get: function () {
            var a = this.r.b1("ComparisonOperator_BottomPercentile");
            return !stringIsNullOrWhiteSpace(a) ? a : "Bottom percentile";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ComparisonOperatorSelector.prototype, "c7", {
        get: function () {
            var a = this.r.b1("ComparisonOperator_Today");
            return !stringIsNullOrWhiteSpace(a) ? a : "Today";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ComparisonOperatorSelector.prototype, "c8", {
        get: function () {
            var a = this.r.b1("ComparisonOperator_Tomorrow");
            return !stringIsNullOrWhiteSpace(a) ? a : "Tomorrow";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ComparisonOperatorSelector.prototype, "de", {
        get: function () {
            var a = this.r.b1("ComparisonOperator_Yesterday");
            return !stringIsNullOrWhiteSpace(a) ? a : "Yesterday";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ComparisonOperatorSelector.prototype, "c5", {
        get: function () {
            var a = this.r.b1("ComparisonOperator_ThisWeek");
            return !stringIsNullOrWhiteSpace(a) ? a : "This week";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ComparisonOperatorSelector.prototype, "cu", {
        get: function () {
            var a = this.r.b1("ComparisonOperator_NextWeek");
            return !stringIsNullOrWhiteSpace(a) ? a : "Next week";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ComparisonOperatorSelector.prototype, "cn", {
        get: function () {
            var a = this.r.b1("ComparisonOperator_LastWeek");
            return !stringIsNullOrWhiteSpace(a) ? a : "Last week";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ComparisonOperatorSelector.prototype, "c3", {
        get: function () {
            var a = this.r.b1("ComparisonOperator_ThisMonth");
            return !stringIsNullOrWhiteSpace(a) ? a : "This month";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ComparisonOperatorSelector.prototype, "cs", {
        get: function () {
            var a = this.r.b1("ComparisonOperator_NextMonth");
            return !stringIsNullOrWhiteSpace(a) ? a : "Next month";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ComparisonOperatorSelector.prototype, "cl", {
        get: function () {
            var a = this.r.b1("ComparisonOperator_LastMonth");
            return !stringIsNullOrWhiteSpace(a) ? a : "Last month";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ComparisonOperatorSelector.prototype, "c4", {
        get: function () {
            var a = this.r.b1("ComparisonOperator_ThisQuarter");
            return !stringIsNullOrWhiteSpace(a) ? a : "This quarter";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ComparisonOperatorSelector.prototype, "ct", {
        get: function () {
            var a = this.r.b1("ComparisonOperator_NextQuarter");
            return !stringIsNullOrWhiteSpace(a) ? a : "Next quarter";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ComparisonOperatorSelector.prototype, "cm", {
        get: function () {
            var a = this.r.b1("ComparisonOperator_LastQuarter");
            return !stringIsNullOrWhiteSpace(a) ? a : "Last quarter";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ComparisonOperatorSelector.prototype, "c6", {
        get: function () {
            var a = this.r.b1("ComparisonOperator_ThisYear");
            return !stringIsNullOrWhiteSpace(a) ? a : "This year";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ComparisonOperatorSelector.prototype, "cv", {
        get: function () {
            var a = this.r.b1("ComparisonOperator_NextYear");
            return !stringIsNullOrWhiteSpace(a) ? a : "Next year";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ComparisonOperatorSelector.prototype, "co", {
        get: function () {
            var a = this.r.b1("ComparisonOperator_LastYear");
            return !stringIsNullOrWhiteSpace(a) ? a : "Last year";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ComparisonOperatorSelector.prototype, "dd", {
        get: function () {
            var a = this.r.b1("ComparisonOperator_YearToDate");
            return !stringIsNullOrWhiteSpace(a) ? a : "Year to date";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ComparisonOperatorSelector.prototype, "cy", {
        get: function () {
            var a = this.r.b1("ComparisonOperator_Q1");
            return !stringIsNullOrWhiteSpace(a) ? a : "Quarter 1";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ComparisonOperatorSelector.prototype, "cz", {
        get: function () {
            var a = this.r.b1("ComparisonOperator_Q2");
            return !stringIsNullOrWhiteSpace(a) ? a : "Quarter 2";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ComparisonOperatorSelector.prototype, "c0", {
        get: function () {
            var a = this.r.b1("ComparisonOperator_Q3");
            return !stringIsNullOrWhiteSpace(a) ? a : "Quarter 3";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ComparisonOperatorSelector.prototype, "c1", {
        get: function () {
            var a = this.r.b1("ComparisonOperator_Q4");
            return !stringIsNullOrWhiteSpace(a) ? a : "Quarter 4";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ComparisonOperatorSelector.prototype, "cr", {
        get: function () {
            var a = this.r.b1("ComparisonOperator_Month");
            return !stringIsNullOrWhiteSpace(a) ? a : "Month";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ComparisonOperatorSelector.prototype, "dc", {
        get: function () {
            var a = this.r.b1("ComparisonOperator_Year");
            return !stringIsNullOrWhiteSpace(a) ? a : "Year";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ComparisonOperatorSelector.prototype, "c2", {
        get: function () {
            var a = this.r.b1("ComparisonOperator_StartsWith");
            return !stringIsNullOrWhiteSpace(a) ? a : "Starts with";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ComparisonOperatorSelector.prototype, "ce", {
        get: function () {
            var a = this.r.b1("ComparisonOperator_DoesNotStartWith");
            return !stringIsNullOrWhiteSpace(a) ? a : "Does not start with";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ComparisonOperatorSelector.prototype, "cg", {
        get: function () {
            var a = this.r.b1("ComparisonOperator_EndsWith");
            return !stringIsNullOrWhiteSpace(a) ? a : "Ends with";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ComparisonOperatorSelector.prototype, "cd", {
        get: function () {
            var a = this.r.b1("ComparisonOperator_DoesNotEndWith");
            return !stringIsNullOrWhiteSpace(a) ? a : "Does not end with";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ComparisonOperatorSelector.prototype, "cb", {
        get: function () {
            var a = this.r.b1("ComparisonOperator_Contains");
            return !stringIsNullOrWhiteSpace(a) ? a : "Contains";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ComparisonOperatorSelector.prototype, "cc", {
        get: function () {
            var a = this.r.b1("ComparisonOperator_DoesNotContain");
            return !stringIsNullOrWhiteSpace(a) ? a : "Does not contain";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ComparisonOperatorSelector.prototype, "cf", {
        get: function () {
            var a = this.r.b1("ComparisonOperator_Empty");
            return !stringIsNullOrWhiteSpace(a) ? a : "Empty";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ComparisonOperatorSelector.prototype, "cw", {
        get: function () {
            var a = this.r.b1("ComparisonOperator_NotEmpty");
            return !stringIsNullOrWhiteSpace(a) ? a : "Not empty";
        },
        enumerable: false,
        configurable: true
    });
    ComparisonOperatorSelector.prototype.ee = function (a) {
        if (a == null) {
            if (this.n != null) {
                var b = this.n;
                b.clicked = delegateRemove(b.clicked, runOn(this, this.d9));
            }
            if (this.f != null) {
                this.f.ab.clear();
                var c = this.f;
                c.cellClicked = delegateRemove(c.cellClicked, runOn(this, this.d6));
            }
            if (this.m != null) {
                var d = this.m;
                d.cellUpdating = delegateRemove(d.cellUpdating, runOn(this, this.eg));
            }
        }
        this.e.t(a);
    };
    ComparisonOperatorSelector.prototype.d7 = function () {
        this.ee(null);
        if (this.f != null) {
            var a = this.f;
            a.cellClicked = delegateRemove(a.cellClicked, runOn(this, this.d6));
        }
        this.u.clear();
    };
    ComparisonOperatorSelector.prototype.d8 = function (a, b, c) {
        this.p = a;
        this.o = b;
        this.o.svgPath = this.bt(this.b);
        this.f = c;
        this.f.h4 = false;
        this.f.ea = 1;
        this.f.cw = 0;
        this.f.ea = 0;
        this.f.ch = 0;
        this.f.my = 0;
        this.f.m8 = 0;
        this.f.f9 = 3;
        this.f.ib = false;
        var d = this.f;
        d.cellClicked = delegateCombine(d.cellClicked, runOn(this, this.d6));
        this.m = new TemplateColumn();
        this.m.width = ((function () {
            var $ret = new ColumnWidth();
            $ret.f = 32;
            $ret.c = false;
            return $ret;
        })());
        this.m.hk = this.m.hl = 4;
        this.m.hm = this.m.hj = 0;
        this.m.io = "Icon";
        var e = this.m;
        e.cellUpdating = delegateCombine(e.cellUpdating, runOn(this, this.eg));
        this.f.columns.add(this.m);
        var f = new TextColumn();
        f.io = "DisplayText";
        f.hk = 0;
        f.e = 0;
        this.f.columns.add(f);
        this.d1();
    };
    ComparisonOperatorSelector.prototype.ec = function (a, b) {
        var _this = this;
        this.s = true;
        for (var c = 0; c < this.u.count; c++) {
            if (this.u._inner[c].a == b && this.u._inner[c].a != 44) {
                this.i = this.u._inner[c];
            }
        }
        this.s = false;
        this.o.svgPath = this.i.Icon;
        if (this.valueChanged != null) {
            this.valueChanged(this, ((function () {
                var $ret = new OperatorSelectorValueChangedEventArgs();
                $ret.oldValue = a;
                $ret.newValue = _this.b;
                return $ret;
            })()));
        }
    };
    ComparisonOperatorSelector.prototype.ea = function () {
        if (this.opening != null) {
            this.opening(this, new OperatorSelectorOpeningEventArgs());
        }
    };
    ComparisonOperatorSelector.prototype.bt = function (a) {
        switch (a) {
            case 7: return ComparisonOperatorSelector.z;
            case 9: return ComparisonOperatorSelector.aa;
            case 12: return ComparisonOperatorSelector.ab;
            case 13: return ComparisonOperatorSelector.bl;
            case 17: return ComparisonOperatorSelector.bm;
            case 15: return ComparisonOperatorSelector.bn;
            case 40: return ComparisonOperatorSelector.bo;
            case 16: return ComparisonOperatorSelector.bp;
            case 0: return "M5 13.5h14v2H5zm0-5h14v2H5z";
            case 11: return ComparisonOperatorSelector.br;
            case 4: return ComparisonOperatorSelector.bu;
            case 5: return ComparisonOperatorSelector.bv;
            case 26: return ComparisonOperatorSelector.bw;
            case 29: return ComparisonOperatorSelector.bx;
            case 23: return ComparisonOperatorSelector.by;
            case 32: return ComparisonOperatorSelector.bz;
            case 2: return ComparisonOperatorSelector.b0;
            case 3: return ComparisonOperatorSelector.b1;
            case 38: return ComparisonOperatorSelector.b2;
            case 24: return ComparisonOperatorSelector.b3;
            case 27: return ComparisonOperatorSelector.b4;
            case 21: return ComparisonOperatorSelector.b5;
            case 30: return ComparisonOperatorSelector.b6;
            case 41: return ComparisonOperatorSelector.b7;
            case 1: return ComparisonOperatorSelector.b8;
            case 34: return ComparisonOperatorSelector.df;
            case 35: return ComparisonOperatorSelector.dg;
            case 36: return ComparisonOperatorSelector.dh;
            case 37: return ComparisonOperatorSelector.di;
            case 14: return ComparisonOperatorSelector.dj;
            case 25: return ComparisonOperatorSelector.dk;
            case 28: return ComparisonOperatorSelector.dl;
            case 22: return ComparisonOperatorSelector.dm;
            case 31: return ComparisonOperatorSelector.dn;
            case 18: return ComparisonOperatorSelector.dp;
            case 19: return ComparisonOperatorSelector.dq;
            case 6: return ComparisonOperatorSelector.dr;
            case 8: return ComparisonOperatorSelector.ds;
            case 10: return ComparisonOperatorSelector.dt;
            case 39: return ComparisonOperatorSelector.dv;
            case 33: return ComparisonOperatorSelector.dw;
            case 20: return ComparisonOperatorSelector.dx;
            default: return "";
        }
    };
    ComparisonOperatorSelector.prototype.bs = function (a) {
        switch (a) {
            case 7: return this.b9;
            case 9: return this.ca;
            case 12: return this.cb;
            case 13: return this.cc;
            case 17: return this.cd;
            case 15: return this.ce;
            case 40: return this.cf;
            case 16: return this.cg;
            case 0: return this.ch;
            case 11: return this.ci;
            case 4: return this.cj;
            case 5: return this.ck;
            case 26: return this.cl;
            case 29: return this.cm;
            case 23: return this.cn;
            case 32: return this.co;
            case 2: return this.cp;
            case 3: return this.cq;
            case 38: return this.cr;
            case 24: return this.cs;
            case 27: return this.ct;
            case 21: return this.cu;
            case 30: return this.cv;
            case 41: return this.cw;
            case 1: return this.cx;
            case 34: return this.cy;
            case 35: return this.cz;
            case 36: return this.c0;
            case 37: return this.c1;
            case 14: return this.c2;
            case 25: return this.c3;
            case 28: return this.c4;
            case 22: return this.c5;
            case 31: return this.c6;
            case 18: return this.c7;
            case 19: return this.c8;
            case 6: return this.c9;
            case 8: return this.da;
            case 10: return this.db;
            case 39: return this.dc;
            case 33: return this.dd;
            case 20: return this.de;
            default: return "";
        }
    };
    ComparisonOperatorSelector.prototype.d1 = function () {
        this.u = new List$1(OperatorModel.$, 0);
        switch (this.d) {
            case 2:
                this.dz(this.u);
                break;
            case 10:
            case 6:
            case 5:
            case 1:
            case 3:
            case 4:
            case 7:
                this.d2(this.u);
                break;
            case 8:
                this.d0(this.u);
                break;
            case 0:
                this.d3(this.u);
                break;
        }
        this.u.o(this.t);
        if (this.f != null) {
            this.e.u(this.u);
            if (this.u.count > 0) {
                this.i = this.u._inner[0];
            }
            this.e.k = Math.min(this.u.count * this.f.mc + 2, this.y);
        }
    };
    ComparisonOperatorSelector.prototype.h = function (a) {
        var _this = this;
        return ((function () {
            var $ret = new OperatorModel();
            $ret.a = a;
            $ret.DisplayText = _this.bs(a);
            $ret.Icon = _this.bt(a);
            return $ret;
        })());
    };
    ComparisonOperatorSelector.prototype.dz = function (a) {
        a.add(this.h(10));
        a.add(this.h(11));
    };
    ComparisonOperatorSelector.prototype.d2 = function (a) {
        a.add(this.h(0));
        a.add(this.h(1));
        a.add(this.h(2));
        a.add(this.h(3));
        a.add(this.h(4));
        a.add(this.h(5));
    };
    ComparisonOperatorSelector.prototype.d0 = function (a) {
        a.add(this.h(0));
        a.add(this.h(1));
        a.add(this.h(2));
        a.add(this.h(3));
        a.add(this.h(4));
        a.add(this.h(5));
        a.add(this.h(38));
        a.add(this.h(39));
        a.add(this.h(18));
        a.add(this.h(20));
        a.add(this.h(19));
        a.add(this.h(22));
        a.add(this.h(23));
        a.add(this.h(21));
        a.add(this.h(25));
        a.add(this.h(26));
        a.add(this.h(24));
        a.add(this.h(28));
        a.add(this.h(29));
        a.add(this.h(27));
        a.add(this.h(31));
        a.add(this.h(32));
        a.add(this.h(30));
        a.add(this.h(33));
        a.add(this.h(34));
        a.add(this.h(35));
        a.add(this.h(36));
        a.add(this.h(37));
    };
    ComparisonOperatorSelector.prototype.d3 = function (a) {
        a.add(this.h(0));
        a.add(this.h(1));
        a.add(this.h(14));
        a.add(this.h(15));
        a.add(this.h(16));
        a.add(this.h(17));
        a.add(this.h(12));
        a.add(this.h(13));
        a.add(this.h(40));
        a.add(this.h(41));
    };
    ComparisonOperatorSelector.prototype.x = function () {
        if (this.f != null) {
            var a = Math.min(8, this.f.actualDataSource != null ? this.f.actualDataSource.actualCount : 0);
            return a * (this.f.mc + this.f.m8) + this.f.mb + 2;
        }
        return 0;
    };
    ComparisonOperatorSelector.prototype.eh = function () {
        if (this.p != null) {
            if (!this.p.t) {
                this.ea();
                this.p.showRelativeToExclusionRect(this.e.v(), 1, 0);
            }
            else {
                this.p.ao();
            }
        }
    };
    ComparisonOperatorSelector.prototype.d5 = function () {
        if (this.p != null) {
            this.p.ao();
        }
    };
    ComparisonOperatorSelector.prototype.dy = function (a, b, c, d) {
        var e = ((function () {
            var $ret = new OperatorModel();
            $ret.DisplayText = a;
            $ret.Icon = b != null ? b : ComparisonOperatorSelector.ad;
            $ret.a = 44;
            $ret.c = c;
            $ret.b = d;
            return $ret;
        })());
        this.t.add(e);
        this.u.add(e);
        if (this.f != null && this.f.renderingEngine != null) {
            this.f.sz(this.u.count, e);
        }
    };
    ComparisonOperatorSelector.prototype.d4 = function () {
        for (var a = 0; a < this.u.count; a++) {
            if (this.u._inner[a].a == 44) {
                this.u.removeAt(a);
                a--;
            }
        }
        this.t.clear();
    };
    ComparisonOperatorSelector.prototype.ef = function (a, b) {
        if (a != null) {
            for (var c = 0; c < this.t.count; c++) {
                if (this.t._inner[c].c == a) {
                    this.i = this.t._inner[c];
                }
            }
        }
        else {
            if (b >= 0 && b < this.t.count) {
                this.i = this.t._inner[b];
            }
        }
    };
    ComparisonOperatorSelector.prototype.d9 = function (a, b) {
        this.eh();
    };
    ComparisonOperatorSelector.prototype.d6 = function (a, b) {
        var c = b.cellInfo.et;
        this.i = this.f.actualDataSource.getItemAtIndex(c);
        this.d5();
    };
    ComparisonOperatorSelector.prototype.eg = function (a, b) {
        this.e.s(b.content, b.cellInfo.g4);
    };
    ComparisonOperatorSelector.$t = markType(ComparisonOperatorSelector, 'ComparisonOperatorSelector', Base.$, [INotifyPropertyChanged_$type]);
    ComparisonOperatorSelector.dt = "M 8 5 A 7 7 0 1 0 15 12 A 7 7 0 0 0 8 5 z M 18 7 A 5 5 0 0 0 15 8.0605469 A 7.48 7.48 0 0 1 15.490234 9.0605469 A 3.89 3.89 0 1 1 15.490234 14.880859 A 8.08 8.08 0 0 1 15 15.880859 A 5 5 0 1 0 18 7 z M 11.179688 8.8203125 L 12.310547 9.9394531 L 7.0703125 15.179688 L 3.6894531 11.810547 L 4.8203125 10.689453 L 7.0703125 12.939453 L 11.179688 8.8203125 z M 16.560547 9.7792969 L 15.779297 10.560547 L 17.210938 12 L 15.779297 13.439453 L 16.560547 14.220703 L 18 12.789062 L 19.439453 14.220703 L 20.220703 13.439453 L 18.789062 12 L 20.220703 10.560547 L 19.439453 9.7792969 L 18 11.210938 L 16.560547 9.7792969 z ";
    ComparisonOperatorSelector.br = "M 8 5 A 7 7 0 1 0 15 12 A 7 7 0 0 0 8 5 z M 18 7 A 5 5 0 0 0 15 8.0605469 A 7.48 7.48 0 0 1 15.490234 9.0605469 A 3.89 3.89 0 1 1 15.490234 14.880859 A 8.08 8.08 0 0 1 15 15.880859 A 5 5 0 1 0 18 7 z M 5.2109375 7.6894531 L 8 10.480469 L 10.789062 7.6894531 L 12.310547 9.2109375 L 9.5195312 12 L 12.310547 14.789062 L 10.789062 16.310547 L 8 13.519531 L 5.2109375 16.310547 L 3.6894531 14.789062 L 6.4804688 12 L 3.6894531 9.2109375 L 5.2109375 7.6894531 z M 19.650391 10.150391 L 17.519531 12.269531 L 16.349609 11.119141 L 15.970703 11.490234 L 15.560547 11.900391 L 15.980469 12.320312 L 17 13.339844 L 17.519531 13.849609 L 20.429688 10.929688 L 19.650391 10.150391 z ";
    ComparisonOperatorSelector.b8 = "M17.37 4.71l-1.74-1-2.76 4.79H5v2h6.71l-1.73 3H5v2h3.82l-2.19 3.79 1.74 1 2.76-4.79H19v-2h-6.71l1.73-3H19v-2h-3.82l2.19-3.79z";
    ComparisonOperatorSelector.ab = "m 3,3 v 18 h 18 v -18 z m 1.9999697,1.9999697 h 14.0000603 v 14.0000603 h -14.0000603 z m 7.2332153,2.9162292 a 3.34,3.34 0 0 0 -0.113159,0.00385 3.54,3.54 0 0 0 -2.2999882,0.7199704 1.93,1.93 0 0 0 -0.8200378,1.6499637 h 1.710023 a 0.93,0.93 0 0 1 0.289947,-0.7099915 1.5,1.5 0 0 1 1.000031,-0.2899476 1.45,1.45 0 0 1 1.00003,0.3500062 1.3,1.3 0 0 1 0.369965,0.9999389 v 0.690033 l -1.369995,-0.03003 a 4.39,4.39 0 0 0 -2.5400401,0.629974 2.07,2.07 0 0 0 -0.8999634,1.78006 2.29,2.29 0 0 0 0.6600038,1.73996 2.63,2.63 0 0 0 1.8900147,0.629974 2.39,2.39 0 0 0 1.320008,-0.369965 3.05,3.05 0 0 0 0.999939,-0.929992 3.72,3.72 0 0 0 0.08002,0.570007 c 0,0.19 0.100034,0.379987 0.160033,0.579986 h 1.789947 a 4.51,4.51 0 0 1 -0.20993,-0.880004 5.5700002,5.5700002 0 0 1 -0.07004,-0.929993 v -3.499969 a 2.44,2.44 0 0 0 -0.839996,-2.0000615 3.34,3.34 0 0 0 -2.106812,-0.7037658 z m -0.315032,4.4605411 a 1.76,1.76 0 0 1 0.08185,0.0033 h 1.400024 v 1.169953 a 1.61,1.61 0 0 1 -0.709992,0.77005 2.27,2.27 0 0 1 -1.210051,0.339935 1.18,1.18 0 0 1 -0.839996,-0.269989 0.92000002,0.92000002 0 0 1 -0.300019,-0.719971 1.16,1.16 0 0 1 0.440003,-0.900055 1.76,1.76 0 0 1 1.138184,-0.393218 z";
    ComparisonOperatorSelector.bl = "M21 19.74V3H4.26L2.89 1.63 1.63 2.92 3 4.29V21h16.73l1.37 1.37 1.27-1.26zM5 19V6.28l5.28 5.27a3.19 3.19 0 00-.81.38 2.07 2.07 0 00-.9 1.78 2.29 2.29 0 00.66 1.74 2.63 2.63 0 001.89.63 2.39 2.39 0 001.32-.37 3.05 3.05 0 001-.93 3.72 3.72 0 00.08.57c0 .19.1.38.16.58h1L17.73 19zm5.79-6.23a1.31 1.31 0 01.45-.25l1.37 1.36.28.29a1.57 1.57 0 01-.19.15 2.27 2.27 0 01-1.21.34 1.18 1.18 0 01-.84-.27.92.92 0 01-.3-.72 1.16 1.16 0 01.44-.9zm2.6-1.47h-.83l-1.62-1.62.08-.1a1.5 1.5 0 011-.29 1.45 1.45 0 011 .35 1.3 1.3 0 01.37 1zM19 17.74l-3.85-3.85v-3.27a2.44 2.44 0 00-.84-2 3.34 3.34 0 00-2.22-.7 3.64 3.64 0 00-2.24.67L6.26 5H19z";
    ComparisonOperatorSelector.dj = "M5.9 7.5l-3.9 9h1.7l.7-1.8h4.1l.7 1.8H11l-3.9-9H5.9zM5 13.2l1.5-4.1L8 13.2H5zm7 1.3h2v2h-2v-2zm8 0h2v2h-2v-2zm-4 0h2v2h-2v-2z";
    ComparisonOperatorSelector.bn = "M3.707,21.707,2.293,20.293l18-18,1.414,1.414ZM6,11H8.757l2-2H6ZM4,3H16.757l2-2H4A2,2,0,0,0,2,3V17.757l2-2ZM6,7h6.757l2-2H6ZM20,21H7.243l-2,2H20a2,2,0,0,0,2-2V6.243l-2,2Z";
    ComparisonOperatorSelector.bp = "M3 14.5h2v2H3zm8 0h2v2h-2zm-4 0h2v2H7zm13.8.3v-3A2.1 2.1 0 0020 10a3 3 0 00-2-.6 3 3 0 00-2 .6 1.7 1.7 0 00-.7 1.5h1.5a.8.8 0 01.3-.7 1.3 1.3 0 01.9-.3 1.3 1.3 0 01.9.4 1.1 1.1 0 01.3.8v.6H18a3.8 3.8 0 00-2.2.6 1.8 1.8 0 00-.8 1.5 2 2 0 00.6 1.6 2.3 2.3 0 001.6.6 2.1 2.1 0 001.2-.4 2.8 2.8 0 00.8-.8 4.3 4.3 0 00.1.5l.1.5H21a4.1 4.1 0 01-.2-.7 5.4 5.4 0 010-1zm-1.6-.5a1.5 1.5 0 01-.6.7 2 2 0 01-1 .2 1.1 1.1 0 01-.8-.2.8.8 0 01-.2-.6 1 1 0 01.3-.8 1.5 1.5 0 011.1-.3h1.2z";
    ComparisonOperatorSelector.bm = "M20.293,2.293l1.414,1.414-18,18L2.293,20.293ZM18,13H15.243l-2,2H18Zm2,8H7.243l-2,2H20a2,2,0,0,0,2-2V6.242l-2,2Zm-2-4H11.243l-2,2H18ZM4,3H16.757l2-2H4A2,2,0,0,0,2,3V17.757l2-2Z";
    ComparisonOperatorSelector.bu = "M6 7.11L15.09 12 6 16.89V19l12-6.46v-1.08L6 5v2.11z";
    ComparisonOperatorSelector.bv = "M5.99 19h12.02v2H5.99zM18 9.47L6 3v2.11L15.09 10 6 14.9v2.11l12-6.47V9.47z";
    ComparisonOperatorSelector.b0 = "M6 12.54L18 19v-2.11L8.91 12 18 7.11V5L6 11.46v1.08z";
    ComparisonOperatorSelector.b1 = "M5.99 19h12.02v2H5.99zM18 14.9L8.91 10 18 5.11V3L6 9.47v1.07l12 6.47V14.9z";
    ComparisonOperatorSelector.bo = "M5 17h2v2H5zm8 0h2v2h-2zm-8-4h2v2H5zm12 4h2v2h-2zM13 5h2v2h-2zM9 17h2v2H9zm8-8h2v2h-2zm0 4h2v2h-2zm0-8h2v2h-2zM5 9h2v2H5zm0-4h2v2H5zm4 0h2v2H9z";
    ComparisonOperatorSelector.b7 = "M5 9h2v2H5zm4 8h2v2H9zm4 0h2v2h-2zm4-8h2v2h-2zm0-4h2v2h-2zM5 17h2v2H5zm8-12h2v2h-2zm-8 8h2v2H5zm14 2v-2h-2v.47L18.53 15H19zm-8-8V5H9v.46L10.54 7H11zM2.76 1.76L1.5 3.06 20.97 22.5l1.26-1.26-8.89-8.89L2.76 1.76z";
    ComparisonOperatorSelector.dp = "m 6,1.9999695 v 2.000061 h -1.0000303 a 2,2 0 0 0 -1.9999697,1.9999695 v 13.99997 a 2,2 0 0 0 1.9999697,2.00006 h 14.0000613 a 2,2 0 0 0 1.99997,-2.00006 v -13.99997 a 2,2 0 0 0 -1.99997,-1.9999695 h -1.00003 v -2.000061 h -1.99997 v 2.000061 h -8.0000613 v -2.000061 z m -1.0000303,7.0000305 h 14.0000613 v 10.99997 h -14.0000613 z m 10.4700623,1.99997 -4.880035,4.880035 -2.1199957,-2.119995 -1.0599975,1.059998 3.1799932,3.179992 5.940033,-5.940033 z";
    ComparisonOperatorSelector.dq = "m 6,1.9999695 v 2.000061 h -1.0000303 c -1.1000002,0 -1.9999697,0.8999693 -1.9999697,1.9999695 v 13.99997 c 0,1.099999 0.8999695,2.00006 1.9999697,2.00006 h 14.0000603 c 1.1,0 1.999969,-0.900061 1.999969,-2.00006 v -13.99997 c 0,-1.1000002 -0.899969,-1.9999695 -1.999969,-1.9999695 h -1.000031 v -2.000061 h -1.999969 v 2.000061 h -8.0000603 v -2.000061 z m -1.0000303,7.0000305 h 14.0000603 v 10.99997 h -14.0000603 z m 8.2999883,1.99997 v 2.600005 h -6.0999763 v 1.800019 h 6.0999763 v 2.600006 l 3.50006,-3.49997 z";
    ComparisonOperatorSelector.dx = "M 6,1.9999688 V 4.0000237 H 4.9999697 A 2,1.9999939 0 0 0 3,5.9999872 V 19.999914 a 2,1.9999939 0 0 0 1.9999697,2.000055 H 19.00003 A 2,1.9999939 0 0 0 21,19.999914 V 5.9999872 A 2,1.9999939 0 0 0 19.00003,4.0000237 H 18 V 1.9999688 H 16.00003 V 4.0000237 H 7.9999697 V 1.9999688 Z M 4.9999697,8.9999779 H 19.00003 V 19.999914 H 4.9999697 Z m 5.6800223,1.9999641 -3.4899895,3.50005 3.4899895,3.499959 v -2.619957 h 6.130005 v -1.750025 h -6.130005 z";
    ComparisonOperatorSelector.dk = "m 6,1.0000305 v 1.9999695 h -1.0000303 a 2,2 0 0 0 -1.9999697,1.9999697 v 15.0000003 a 2,2 0 0 0 1.9999697,2.00006 h 7.0000313 v -2.00006 h -7.0000313 v -12.0000003 h 14.0000613 v 4.0000303 h 1.99997 v -7.0000303 a 2,2 0 0 0 -1.99997,-1.9999697 h -1.00003 v -1.9999695 h -1.99997 v 1.9999695 h -8.0000613 v -1.9999695 z m 0,7.9999695 v 1.99997 h 1.9999697 v -1.99997 z m 4.99997,0 v 1.99997 h 2.000061 v -1.99997 z m 5.000061,0 v 1.99997 h 1.99997 v -1.99997 z m -10.000031,4.00003 v 1.99997 h 1.9999697 v -1.99997 z m 4.99997,0 v 1.99997 h 2.000061 v -1.99997 z m 7.039581,1.025208 a 4.5,4.5 0 1 0 4.960419,4.474732 4.47,4.47 0 0 0 -1.999969,-3.73993 4.5,4.5 0 0 0 -2.96045,-0.734802 z m 1.960419,2.804718 0.709991,0.710083 -2.649993,2.629944 -1.749939,-1.76001 0.689941,-0.709991 1.050018,1.00003 z m -13.99997,0.170014 v 2.00006 h 1.9999697 v -2.00006 z m 4.99997,0 v 2.00006 h 2.000061 v -2.00006 z";
    ComparisonOperatorSelector.b3 = "m 4.9999689,1.0000305 v 1.9999695 h -0.9999391 a 2,2 0 0 0 -2.000061,1.9999697 v 15.0000003 a 2,2 0 0 0 2.000061,2.00006 h 6.9999382 v -2.00006 h -6.9999382 v -12.0000003 h 13.9999692 v 4.0000303 h 1.999969 v -7.0000303 a 2,2 0 0 0 -1.999969,-1.9999697 h -1.000031 v -1.9999695 h -1.999969 v 1.9999695 h -7.9999694 v -1.9999695 z m 0,7.9999695 v 1.99997 h 2.0000607 v -1.99997 z m 5.0000611,0 v 1.99997 h 1.999969 v -1.99997 z m 4.999969,0 v 1.99997 h 1.999969 v -1.99997 z m -10.0000301,4.00003 v 1.99997 h 2.0000607 v -1.99997 z m 5.0000611,0 v 1.99997 h 1.999969 v -1.99997 z m 7.039489,1.025208 a 4.5,4.5 0 1 0 4.96051,4.474732 4.47,4.47 0 0 0 -2.000061,-3.73993 4.5,4.5 0 0 0 -2.960449,-0.734802 z m 0.96048,1.474732 3,3 -3,3 v -1.99997 h -4.000031 v -1.99997 h 4.000031 z m -13.0000301,1.5 v 2.00006 h 2.0000607 v -2.00006 z m 5.0000611,0 v 2.00006 h 1.999969 v -2.00006 z";
    ComparisonOperatorSelector.bw = "m 4.9999689,1.0000305 v 1.9999695 h -0.9999391 a 2,2 0 0 0 -2.000061,1.9999697 v 15.0000003 a 2,2 0 0 0 2.000061,2.00006 h 6.9999382 v -2.00006 h -6.9999382 v -12.0000003 h 13.9999692 v 4.0000303 h 1.999969 v -7.0000303 a 2,2 0 0 0 -1.999969,-1.9999697 h -1.000031 v -1.9999695 h -1.999969 v 1.9999695 h -7.9999694 v -1.9999695 z m 0,7.9999695 v 1.99997 h 2.0000607 v -1.99997 z m 5.0000611,0 v 1.99997 h 1.999969 v -1.99997 z m 4.999969,0 v 1.99997 h 1.999969 v -1.99997 z m -10.0000301,4.00003 v 1.99997 h 2.0000607 v -1.99997 z m 5.0000611,0 v 1.99997 h 1.999969 v -1.99997 z m 7.499999,0.99994 a 4.48,4.48 0 1 0 4.5,4.5 4.47,4.47 0 0 0 -4.5,-4.5 z m -0.500061,1.5 v 2.00006 h 4.000031 v 1.99997 h -4.000031 v 1.99997 l -3,-3 z m -11.9999991,1.5 v 2.00006 h 2.0000607 v -2.00006 z m 5.0000611,0 v 2.00006 h 1.999969 v -2.00006 z";
    ComparisonOperatorSelector.dn = "m 4.0000313,1.0000305 v 1.9999695 h -1.0000305 a 2,2 0 0 0 -1.9999695,1.9999697 v 12.0000003 a 2,2 0 0 0 1.9999695,2.00006 h 13.9999702 a 2,2 0 0 0 2.000061,-2.00006 v -12.0000003 a 2,2 0 0 0 -2.000061,-1.9999697 h -0.999939 v -1.9999695 h -2.000061 v 1.9999695 h -7.9999702 v -1.9999695 z m -1.0000305,5.9999998 h 13.9999702 v 9.9999397 h -13.9999702 z m 9.9200142,2.0799867 -4.0699777,4.069977 -1.7700806,-1.769989 -0.8799131,0.889984 2.6499937,2.649994 4.9499827,-4.959961 z m 8.079986,0.920013 v 10.99997 h -13.9999699 v 1.99997 h 13.9999699 a 2,2 0 0 0 1.99997,-1.99997 v -10.99997 z";
    ComparisonOperatorSelector.b6 = "m 4.0000313,1.0000305 v 1.9999695 h -1.0000305 a 2,2 0 0 0 -1.9999695,1.9999697 v 12.0000003 a 2,2 0 0 0 1.9999695,2.00006 h 13.9999702 a 2,2 0 0 0 2.000061,-2.00006 v -12.0000003 a 2,2 0 0 0 -2.000061,-1.9999697 h -0.999939 v -1.9999695 h -2.000061 v 1.9999695 h -7.9999702 v -1.9999695 z m -1.0000305,5.9999998 h 13.9999702 v 9.9999397 h -13.9999702 z m 8.1299742,1.9999697 v 2.25 h -5.25 v 1.5 h 5.25 v 2.25 l 3,-3 z m 9.870026,1.00003 v 10.99997 h -13.9999699 v 1.99997 h 13.9999699 a 2,2 0 0 0 1.99997,-1.99997 v -10.99997 z";
    ComparisonOperatorSelector.bz = "m 4.0000313,1.0000305 v 1.9999695 h -1.0000305 a 2,2 0 0 0 -1.9999695,1.9999697 v 12.0000003 a 2,2 0 0 0 1.9999695,2.00006 h 13.9999702 a 2,2 0 0 0 2.000061,-2.00006 v -12.0000003 a 2,2 0 0 0 -2.000061,-1.9999697 h -0.999939 v -1.9999695 h -2.000061 v 1.9999695 h -7.9999702 v -1.9999695 z m -1.0000305,5.9999998 h 13.9999702 v 9.9999397 h -13.9999702 z m 5.869995,1.9999697 -2.9900208,3 2.9900208,3 v -2.25 h 5.2599792 v -1.5 h -5.2599792 z m 12.1300052,1.00003 v 10.99997 h -13.9999699 v 1.99997 h 13.9999699 a 2,2 0 0 0 1.99997,-1.99997 v -10.99997 z";
    ComparisonOperatorSelector.dl = "M12,7V17H22A10,10,0,0,0,12,7Zm-2,5L6,16V13H2V11H6V8Z";
    ComparisonOperatorSelector.b4 = "M4,9.253A8.03,8.03,0,0,1,9.747,15H4V9.253M2,7V17H12A10,10,0,0,0,2,7ZM18,8v3H14v2h4v3l4-4Z";
    ComparisonOperatorSelector.bx = "M12,7V17H22A10,10,0,0,0,12,7ZM2,12l4,4V13h4V11H6V8Z";
    ComparisonOperatorSelector.dm = "M22,4V20a2,2,0,0,1-2,2H15V20h5V4H4V20H9v2H4a2,2,0,0,1-2-2V4A2,2,0,0,1,4,2H20A2,2,0,0,1,22,4ZM18,6H6V9H18ZM8,15h3v7h2V15h3l-4-4Z";
    ComparisonOperatorSelector.b5 = "M20,2H4A2,2,0,0,0,2,4V20a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V4A2,2,0,0,0,20,2Zm0,18H4V4H20ZM18,9H6V6H18Zm0,5-4,4V15H6V13h8V10Z";
    ComparisonOperatorSelector.by = "M20,2H4A2,2,0,0,0,2,4V20a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V4A2,2,0,0,0,20,2Zm0,18H4V4H20Zm-2-2H6V15H18ZM10,6V9h8v2H10v3L6,10Z";
    ComparisonOperatorSelector.dw = "M20,2H4A2,2,0,0,0,2,4V20a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V4A2,2,0,0,0,20,2Zm0,18H4V4H20ZM5,10H6.127L7.2,11.58,8.258,10H9.379l-1.7,2.465V14H6.677V12.442Zm5.044.74V10h3.745v.74h-1.37V14H11.414V10.74ZM16.926,10a2.667,2.667,0,0,1,.823.123,1.86,1.86,0,0,1,.659.37,1.679,1.679,0,0,1,.435.616,2.205,2.205,0,0,1,.157.868,2.456,2.456,0,0,1-.128.807,1.7,1.7,0,0,1-.387.639,1.828,1.828,0,0,1-.647.423,2.453,2.453,0,0,1-.912.154H14.954V10Zm-.07,3.26a1.46,1.46,0,0,0,.422-.061.951.951,0,0,0,.365-.205,1.007,1.007,0,0,0,.256-.372,1.453,1.453,0,0,0,.1-.56,2.054,2.054,0,0,0-.067-.547,1.046,1.046,0,0,0-.221-.417.973.973,0,0,0-.407-.266,1.818,1.818,0,0,0-.624-.092h-.717v2.52Z";
    ComparisonOperatorSelector.df = "M8.5,22a6.5,6.5,0,0,1,0-13h.65v5.85H15v.65A6.508,6.508,0,0,1,8.5,22ZM7.85,10.34a5.2,5.2,0,1,0,5.81,5.81H7.85ZM11,2V13H22A11,11,0,0,0,11,2Zm5,8H15V6h1Z";
    ComparisonOperatorSelector.dg = "M2,8.5a6.5,6.5,0,0,1,13,0v.65H9.15V15H8.5A6.508,6.508,0,0,1,2,8.5Zm11.66-.65a5.2,5.2,0,1,0-5.81,5.81V7.85ZM11,11V22A11,11,0,0,0,22,11Zm4,6H14V13h1Zm2,0H16V13h1Z";
    ComparisonOperatorSelector.dh = "M15.5,2a6.5,6.5,0,0,1,0,13h-.65V9.15H9V8.5A6.508,6.508,0,0,1,15.5,2Zm.65,11.66a5.2,5.2,0,1,0-5.81-5.81h5.81ZM2,11A11,11,0,0,0,13,22V11Zm5,6H6V13H7Zm2,0H8V13H9Zm2,0H10V13h1Z";
    ComparisonOperatorSelector.di = "M22,15.5a6.5,6.5,0,0,1-13,0v-.65h5.85V9h.65A6.508,6.508,0,0,1,22,15.5Zm-11.66.65a5.2,5.2,0,1,0,5.81-5.81v5.81ZM2,13H13V2A11,11,0,0,0,2,13Zm5-2H6V7H7Zm3,0L8,7H9l1,2,1-2h1Z";
    ComparisonOperatorSelector.b2 = "M20,2H4A2,2,0,0,0,2,4V20a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V4A2,2,0,0,0,20,2Zm0,18H4V4H20ZM11,9H9V7h2Zm4,0H13V7h2ZM7,13H5V11H7Zm4,0H9V11h2Zm4,0H13V11h2Zm4,0H17V11h2ZM7,17H5V15H7Zm4,0H9V15h2Zm4,0H13V15h2Zm4-8H17V7h2Z";
    ComparisonOperatorSelector.dv = "M20,2H4A2,2,0,0,0,2,4V20a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V4A2,2,0,0,0,20,2Zm0,18H4V4H20ZM7.7,11.634a1.151,1.151,0,0,0,.317-.063.618.618,0,0,0,.243-.152.367.367,0,0,0,.1-.264.429.429,0,0,0-.2-.379.79.79,0,0,0-.452-.132.689.689,0,0,0-.533.2A.668.668,0,0,0,7,11.331H6.112a1.428,1.428,0,0,1,.127-.542,1.246,1.246,0,0,1,.321-.42,1.465,1.465,0,0,1,.5-.273A2.022,2.022,0,0,1,7.7,10a2.258,2.258,0,0,1,.55.069,1.7,1.7,0,0,1,.5.206,1.21,1.21,0,0,1,.357.336.784.784,0,0,1,.137.456.8.8,0,0,1-.16.495.815.815,0,0,1-.482.292v.011a1.04,1.04,0,0,1,.6.308.813.813,0,0,1,.216.567,1.041,1.041,0,0,1-.14.539,1.238,1.238,0,0,1-.377.4,1.785,1.785,0,0,1-.544.242A2.605,2.605,0,0,1,7,13.906a1.542,1.542,0,0,1-.54-.272,1.207,1.207,0,0,1-.344-.438A1.322,1.322,0,0,1,6,12.6h.885a.931.931,0,0,0,.058.294.7.7,0,0,0,.151.243.727.727,0,0,0,.246.162.925.925,0,0,0,.35.06.86.86,0,0,0,.531-.162.524.524,0,0,0,.216-.443.5.5,0,0,0-.1-.335.59.59,0,0,0-.259-.168,1.281,1.281,0,0,0-.344-.061c-.125-.005-.244-.008-.357-.008v-.55A2.453,2.453,0,0,0,7.7,11.634Zm4.814-.9a.591.591,0,0,0-.406-.143.684.684,0,0,0-.416.123.949.949,0,0,0-.265.3,1.42,1.42,0,0,0-.144.382,1.989,1.989,0,0,0-.052.363l.012.011a1.072,1.072,0,0,1,.446-.329,1.685,1.685,0,0,1,1.166.008,1.449,1.449,0,0,1,.478.288,1.1,1.1,0,0,1,.269.4,1.306,1.306,0,0,1,.085.457,1.338,1.338,0,0,1-.115.552,1.3,1.3,0,0,1-.327.446,1.549,1.549,0,0,1-.508.3,1.915,1.915,0,0,1-.655.107,1.877,1.877,0,0,1-.858-.174,1.491,1.491,0,0,1-.544-.453,1.7,1.7,0,0,1-.281-.636,3.3,3.3,0,0,1-.079-.724,2.713,2.713,0,0,1,.1-.715,1.924,1.924,0,0,1,.315-.646,1.65,1.65,0,0,1,.556-.471A1.752,1.752,0,0,1,12.118,10a2.055,2.055,0,0,1,.55.071,1.517,1.517,0,0,1,.453.207,1.116,1.116,0,0,1,.32.333,1.177,1.177,0,0,1,.164.456h-.884A.638.638,0,0,0,12.511,10.732Zm-.782,1.257a.627.627,0,0,0-.233.157.664.664,0,0,0-.138.228.821.821,0,0,0-.045.272.732.732,0,0,0,.049.262.7.7,0,0,0,.144.231.706.706,0,0,0,.232.162.783.783,0,0,0,.315.06.692.692,0,0,0,.3-.06.72.72,0,0,0,.219-.16.67.67,0,0,0,.138-.225.773.773,0,0,0,.046-.259.828.828,0,0,0-.043-.266.683.683,0,0,0-.128-.232.624.624,0,0,0-.219-.165.726.726,0,0,0-.311-.063A.836.836,0,0,0,11.729,11.989Zm4.129-1.268-.183.875.013.01a1.2,1.2,0,0,1,.406-.228,1.783,1.783,0,0,1,1.094.036,1.326,1.326,0,0,1,.442.28,1.186,1.186,0,0,1,.275.416,1.355,1.355,0,0,1,.095.509,1.159,1.159,0,0,1-.137.553,1.456,1.456,0,0,1-.371.443,1.694,1.694,0,0,1-.54.288,1.983,1.983,0,0,1-.655.1,2.7,2.7,0,0,1-.638-.074,1.725,1.725,0,0,1-.541-.229,1.226,1.226,0,0,1-.377-.382,1.054,1.054,0,0,1-.147-.531h.93a.607.607,0,0,0,.236.421.922.922,0,0,0,.848.093.773.773,0,0,0,.249-.165.706.706,0,0,0,.157-.237.718.718,0,0,0,.056-.277.754.754,0,0,0-.052-.281.64.64,0,0,0-.158-.231.738.738,0,0,0-.248-.154.932.932,0,0,0-.334-.055.957.957,0,0,0-.406.074.91.91,0,0,0-.3.234h-.838l.452-2.129h2.561v.644Z";
    ComparisonOperatorSelector.dr = "m 8.015625,15 c 0,0 0,0 0,0 8,0 8,0 8,0 -4,-6 -4,-6 -4,-6 z";
    ComparisonOperatorSelector.z = "m 8.015625,9 c 0,0 0,0 0,0 8,0 8,0 8,0 -4,6 -4,6 -4,6 z";
    ComparisonOperatorSelector.ds = "m 10.085911,4.8515625 c -0.514323,0 -0.9227906,0.16686 -1.2255249,0.5005187 -0.3027344,0.3336592 -0.4541016,0.7902023 -0.4541016,1.3696289 0,0.5305992 0.1431986,0.9545592 0.429657,1.2719423 0.2864583,0.3173827 0.6706034,0.4760743 1.1523742,0.4760743 0.4980473,0 0.9008793,-0.1684571 1.2084963,-0.5053711 0.307617,-0.3369141 0.461426,-0.7852885 0.461426,-1.3451846 0,-0.5598956 -0.137564,-0.9944658 -0.412629,-1.3037109 -0.275065,-0.3092446 -0.661651,-0.4638976 -1.159698,-0.4638976 z m 3.88678,0.1073913 -4.4873659,7.0508432 h 0.6982729 l 4.492218,-7.0508432 z m -3.916077,0.4297485 c 0.296224,0 0.529846,0.1098634 0.700745,0.3295899 0.170898,0.2197265 0.256347,0.5264999 0.256347,0.9203798 0,0.4036458 -0.08629,0.7194318 -0.258819,0.9472959 -0.172526,0.2278645 -0.411784,0.3417666 -0.717774,0.3417666 -0.3027341,0 -0.5419919,-0.1098633 -0.7177731,-0.3295899 -0.1757812,-0.2197265 -0.2636718,-0.5264995 -0.2636718,-0.9203798 0,-0.4003908 0.089488,-0.7153322 0.2685242,-0.9448242 0.1790362,-0.2294922 0.423177,-0.3442383 0.7324217,-0.3442383 z m 4.199249,3.0517275 c -0.507812,0 -0.914683,0.168457 -1.220672,0.5053711 -0.30599,0.336914 -0.459046,0.7950544 -0.459046,1.3744811 0,0.527344 0.14329,0.950551 0.429749,1.269562 0.286458,0.31901 0.670511,0.478546 1.152283,0.478546 0.498047,0 0.900879,-0.168457 1.208496,-0.505371 0.307617,-0.336914 0.461426,-0.783692 0.461426,-1.340332 0,-0.5631505 -0.138317,-1.0010075 -0.415009,-1.3135072 -0.276693,-0.3125002 -0.662435,-0.46875 -1.157227,-0.46875 z m -0.0293,0.5517881 c 0.296223,0 0.529754,0.107422 0.700653,0.3222656 0.170898,0.2148441 0.256347,0.5207728 0.256347,0.9179075 0,0.400391 -0.0862,0.715332 -0.258728,0.944825 -0.172526,0.229492 -0.411784,0.344238 -0.717773,0.344238 -0.302735,0 -0.541992,-0.109863 -0.717774,-0.32959 -0.175781,-0.219726 -0.263672,-0.523213 -0.263672,-0.910584 0,-0.4036449 0.08864,-0.7194305 0.266053,-0.9472955 0.177408,-0.2278646 0.422393,-0.3417666 0.734894,-0.3417666 z m -2.210907,4.1797491 -4.000031,5.999999 h 7.99997 z";
    ComparisonOperatorSelector.aa = "m 8.015625,4.0546875 4.000031,6.0000005 3.999939,-6.0000005 z m 2.070282,8.6795655 c -0.514323,0 -0.9227906,0.16686 -1.2255249,0.500519 -0.3027344,0.333659 -0.4541016,0.790202 -0.4541016,1.369629 0,0.530599 0.1431986,0.954559 0.429657,1.271942 0.2864583,0.317382 0.6706034,0.476073 1.1523742,0.476073 0.4980473,0 0.9008793,-0.168457 1.2084963,-0.50537 0.307617,-0.336914 0.461426,-0.785288 0.461426,-1.345184 0,-0.559896 -0.137564,-0.994466 -0.412629,-1.303711 -0.275065,-0.309245 -0.661651,-0.463898 -1.159698,-0.463898 z m 3.88678,0.107483 -4.4873659,7.05075 h 0.6982729 l 4.492218,-7.05075 z m -3.916077,0.429657 c 0.296224,0 0.529846,0.109863 0.700745,0.32959 0.170898,0.219726 0.256347,0.5265 0.256347,0.92038 0,0.403646 -0.08629,0.719432 -0.258819,0.947296 -0.172526,0.227865 -0.411784,0.341766 -0.717774,0.341766 -0.3027341,0 -0.5419919,-0.109864 -0.7177731,-0.32959 -0.1757812,-0.219726 -0.2636718,-0.526499 -0.2636718,-0.920379 0,-0.400392 0.089488,-0.715333 0.2685242,-0.944825 0.1790362,-0.229492 0.423177,-0.344238 0.7324217,-0.344238 z m 4.199249,3.051726 c -0.507812,0 -0.914683,0.168458 -1.220672,0.505372 -0.30599,0.336914 -0.459046,0.795146 -0.459046,1.374572 0,0.527344 0.14329,0.950459 0.429749,1.269472 0.286458,0.319009 0.670511,0.478545 1.152283,0.478545 0.498047,0 0.900879,-0.168457 1.208496,-0.505371 0.307617,-0.336914 0.461426,-0.783692 0.461426,-1.340332 0,-0.563151 -0.138317,-1.001006 -0.415009,-1.313508 -0.276693,-0.312499 -0.662435,-0.46875 -1.157227,-0.46875 z m -0.0293,0.551789 c 0.296223,0 0.529754,0.107422 0.700653,0.322267 0.170898,0.214842 0.256347,0.520863 0.256347,0.917998 0,0.400392 -0.0862,0.715332 -0.258728,0.944825 -0.172526,0.229492 -0.411784,0.344238 -0.717773,0.344238 -0.302735,0 -0.541992,-0.109863 -0.717774,-0.32959 -0.175781,-0.219727 -0.263672,-0.523305 -0.263672,-0.910674 0,-0.403647 0.08864,-0.719431 0.266053,-0.947297 0.177408,-0.227865 0.422393,-0.341766 0.734894,-0.341767 z";
    ComparisonOperatorSelector.ad = "M12.138 21H8.2a1.171 1.171 0 01-1.152-1.188v-5.937L2.123 4.719A1.187 1.187 0 013.153 3h14.694a1.187 1.187 0 011.03 1.719l-3.763 7a2.2 2.2 0 00-.437.642h-.3a2.206 2.206 0 00-1.922 1.11l-.9 1.553-.058.109a2.246 2.246 0 00.212 2.366 2.185 2.185 0 00-.168 2.462zm9.775-2.319a.21.21 0 01.056.281l-.9 1.564a.226.226 0 01-.27.1l-1.113-.449a3.415 3.415 0 01-.754.438l-.18 1.193a.221.221 0 01-.225.191h-1.8a.228.228 0 01-.225-.191l-.169-1.193a3.233 3.233 0 01-.765-.438l-1.114.449a.236.236 0 01-.281-.1l-.9-1.564a.213.213 0 01.056-.281l.945-.742a5.864 5.864 0 01-.022-.439 2.709 2.709 0 01.045-.439l-.956-.742a.224.224 0 01-.057-.293l.9-1.552a.222.222 0 01.27-.1l1.125.45a3.581 3.581 0 01.754-.438l.169-1.193a.228.228 0 01.225-.193h1.8a.23.23 0 01.225.191l.169 1.193a3.348 3.348 0 01.753.438l1.125-.45a.217.217 0 01.27.1l.9 1.552a.225.225 0 01-.056.293l-.956.742A1.8 1.8 0 0121 17.5c0 .146-.011.293-.023.439zM19.236 17.5a1.609 1.609 0 10-1.609 1.609 1.609 1.609 0 001.609-1.609z";
    return ComparisonOperatorSelector;
}(Base));
export { ComparisonOperatorSelector };
//# sourceMappingURL=ComparisonOperatorSelectorView_combined.js.map
